import { render, staticRenderFns } from "./Erro404.vue?vue&type=template&id=346c5d10&"
import script from "./Erro404.vue?vue&type=script&lang=js&"
export * from "./Erro404.vue?vue&type=script&lang=js&"
import style0 from "./Erro404.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports